import React from 'react'

function FeesManagement() {
  return (
    <div>
      This page is to manange moneyyyyyyyyyyyyyy
    </div>
  )
}

export default FeesManagement
